export default __webpack_public_path__ + "static/media/fontRoboto400_latin.b009a76a.woff2";